(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('best-sellers-carousel')) {
    class BestSellersCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-best-sellers-track]');
        if (!this.track) return;
        this.prevBtn = this.querySelector('.js-prev');
        this.nextBtn = this.querySelector('.js-next');

        this.onScroll = () => this.update();
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        if (this.prevBtn) this.prevBtn.onclick = () => this.go(-1);
        if (this.nextBtn) this.nextBtn.onclick = () => this.go(1);

        this.update();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      step() {
        const card = this.track.querySelector('.best-sellers__card');
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      go(direction) {
        this.track.scrollBy({ left: direction * this.step(), behavior: 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= max - 2;
      }
    }

    customElements.define('best-sellers-carousel', BestSellersCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('customer-reviews-carousel')) {
    class CustomerReviewsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-customer-reviews-track]');
        if (!this.track) return;
        this.prevBtn = this.querySelector('.js-prev');
        this.nextBtn = this.querySelector('.js-next');

        this.onScroll = () => this.update();
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        if (this.prevBtn) this.prevBtn.onclick = () => this.go(-1);
        if (this.nextBtn) this.nextBtn.onclick = () => this.go(1);

        this.update();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      step() {
        const card = this.track.querySelector('.customer-reviews__card');
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      go(direction) {
        this.track.scrollBy({ left: direction * this.step(), behavior: 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= max - 2;
      }
    }

    customElements.define('customer-reviews-carousel', CustomerReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({ note: event.target.value });
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-by-category-carousel')) {
    class ShopByCategoryCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-shop-by-category-track]');
        if (!this.track) return;
        this.prevBtn = this.querySelector('.js-prev');
        this.nextBtn = this.querySelector('.js-next');

        this.onScroll = () => this.update();
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        if (this.prevBtn) this.prevBtn.onclick = () => this.go(-1);
        if (this.nextBtn) this.nextBtn.onclick = () => this.go(1);

        this.update();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      step() {
        const card = this.track.querySelector('.shop-by-category__card');
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      go(direction) {
        this.track.scrollBy({ left: direction * this.step(), behavior: 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= max - 2;
      }
    }

    customElements.define('shop-by-category-carousel', ShopByCategoryCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
